<template>
	<button type="button" class="toggle" @click="openSettings">
		{{ $t('WEBAPP_PRIVACY_CONSENT_MANAGEMENT_TITLE') }}
	</button>
</template>

<script setup lang="ts">
import { hasUCConsentBanner } from '@/helpers/tracking';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

// LowPriorityComponents already loads the consent-banner chunk. just making sure it's in the same chunk name.
const ConsentModal = defineAsyncComponent(
	() => import(/* webpackChunkName: "consent-banner" */ '@/components/modals/ConsentModal.vue')
);

const { webLocale } = storeToRefs(useLanguageStore());

function openSettings() {
	if (hasUCConsentBanner(webLocale.value)) {
		window.__ucCmp.showFirstLayer();
	} else {
		ModalHelper.openModal(ConsentModal);
	}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.toggle {
	all: unset;
	cursor: pointer;
	color: $jw-color-lightblue;

	&:hover,
	&:focus {
		color: $jw-color-lightgray;
	}
}
</style>
